export default function xmlToString(xml) {
  //code for IE
  if (window.ActiveXObject) {
    return xml.xml;
  }

  // code for Chrome, Safari, Firefox, Opera, etc.
  return new XMLSerializer().serializeToString(xml);
}
